<template>
  <div class="excellent-cases-wrapper">
    <div class="left-blank"></div>
    <div class="content-area">
      <div class="title-row">
        <div class="title">优秀客户案例</div>
        <div class="carousel-btn-group">
          <button
            class="carousel-btn left"
            @click="prev"
            :disabled="currentIndex === 0"
          >
            &#8592;
          </button>
          <button
            class="carousel-btn right"
            @click="next"
            :disabled="currentIndex === images.length - 1"
          >
            &#8594;
          </button>
        </div>
      </div>
      <div class="carousel-container">
        <div
          class="carousel-image current"
          :style="{ backgroundImage: `url(${images[currentIndex]})` }"
        ></div>
        <div
          v-if="images.length > 1 && nextIndex !== currentIndex"
          class="carousel-image next"
          :style="{ backgroundImage: `url(${images[nextIndex]})` }"
        ></div>
      </div>
      <!-- <div class="carousel-indicators">
        <span
          v-for="(img, idx) in images"
          :key="img"
          :class="['dot', { active: idx === currentIndex }]"
          @click="goTo(idx)"
        ></span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ExcellentCases",
  data() {
    return {
      images: [
        require("@/assets/first/khal_img01.svg"),
        require("@/assets/first/khal_img02.svg"),
        require("@/assets/first/khal_img03.svg"),
        require("@/assets/first/khal_img04.svg"),
        require("@/assets/first/khal_img05.svg"),
        require("@/assets/first/khal_img06.svg"),
      ],
      currentIndex: 0,
    };
  },
  computed: {
    nextIndex() {
      return (this.currentIndex + 1) % this.images.length;
    },
  },
  methods: {
    prev() {
      if (this.currentIndex > 0) this.currentIndex--;
    },
    next() {
      if (this.currentIndex < this.images.length - 1) this.currentIndex++;
    },
    goTo(idx) {
      this.currentIndex = idx;
    },
  },
};
</script>

<style scoped>
.excellent-cases-wrapper {
  padding: 60px 0 60px 100px;
  width: 100%;
  /* display: flex; */
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background: transparent;
}
.left-blank {
  flex: 0 0 9%;
  max-width: 9%;
}
.content-area {
  flex: 0 0 91%;
  max-width: 91vw;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.title-row {
  width: 79%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.title {
  width: 216px;
  height: 36px;
  font-size: 36px;
  font-family: Microsoft YaHei, Microsoft YaHei-700;
  font-weight: 700;
  text-align: LEFT;
  color: #2c3239;
  line-height: 36px;
}
.carousel-btn-group {
  display: flex;
  gap: 8px;
}
.carousel-btn {
  color: #fff;
  border: none;
  width: 72px;
  height: 48px;
  font-size: 22px;
  cursor: pointer;
  opacity: 0.85;
  transition: background 0.2s;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
  background: #0b5cfe;
  border-radius: 8px;
}
.carousel-btn:disabled {
  background: #e0e0e0;
  color: #aaa;
  cursor: not-allowed;
}
.carousel-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 533px;
  overflow: hidden;
  margin: 0;
  position: relative;
}
.carousel-image {
  transition: all 0.5s ease-in-out;
}
.carousel-image.current {
  width: 948px;
  border-radius: 16px 0 0 16px;
  z-index: 2;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  background-size: cover;
}
.carousel-image.next {
  flex: 0 0 40%;
  width: 40%;
  height: 100%;
  border-radius: 0 16px 16px 0;
  margin-left: 10px;
  margin-right: 0;
  z-index: 1;
  filter: blur(2px);
  opacity: 0.8;
  background-color: rgba(255, 255, 255, 0.2);
  background-size: cover;
  background-position: center;
}
/* 添加进入和离开的动画状态 */
.carousel-image.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}
.carousel-image.slide-leave {
  transform: translateX(-100%);
  opacity: 0;
}
.carousel-indicators {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  width: 95%;
  max-width: 948px;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e0e0e0;
  margin: 0 5px;
  cursor: pointer;
  transition: background 0.2s;
}
.dot.active {
  background: #007aff;
}
</style>
